import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core"
import { Subscription } from 'rxjs';
import { RxFormBuilder, IFormGroup, RxwebValidators } from '@rxweb/reactive-form-validators';
import { State, Attachment, USCompliance, USComplianceDocument } from '@app/models';
import { AbstractUploadAttachment } from '../domain/abstract-upload-attachment';
import { MasterLookupGroup } from 'src/app/viewModel/master-lookup-group';
import { MASTER_LOOKUPS } from 'src/app/uris/master-lookups.uri';
import { Router } from '@angular/router';
import { CustomMessage } from 'src/app/components/shared/constant/custom-message';
import { RoutingKeys, StorageKeys } from 'src/app/components/shared/constant/commonConstants';
import { USComplianceViewModel } from 'src/app/viewModel/us-compliance-view-model';
import { USComplianceDocumentBase } from '@app/database-models';
import { FormArray } from '@angular/forms';
import { ModalView } from 'src/app/domain/customize-design/modal';
import { ConfirmationModalComponent } from 'src/app/components/shared/confirmation-modal/confirmation-modal.component';
import { StatusEnum } from 'src/app/enums/status.enum';
import { USComplianceCategoryEnum } from 'src/app/enums/u-s-compliance-category.enum';
import { DownloadFile } from "src/app/components/shared/constant/download-file";
import { access } from "@rxweb/angular-router";
import { ApplicationModules, PermissionNames } from "src/app/enums/application-modules.enum";

@access({ accessLevel: ApplicationModules.HRComplianceForms, action: PermissionNames.Post })

@Component({
    selector: "app-upload-attachment-add",
    templateUrl: './upload-attachment-add.component.html'
})
export class UploadAttachmentAddComponent extends AbstractUploadAttachment implements OnInit, OnDestroy {
    usCompliance: USComplianceViewModel;
    subscription: Subscription;
    masterLookupGroup: MasterLookupGroup;
    fileType: string;
    isCategorySelected: boolean = false;
    attachmentArray: USComplianceDocument[] = [];
    isComplianceLookup: boolean = false;
    isStateLookup: boolean = false;
    isTitle: boolean = false;
    uSComplianceDocument: any;
    isDocument: boolean = false;
    isURL: boolean = false;
    modalView: ModalView;
    addButton: boolean = false;
    selectedFilename:string;
    constructor(private formBuilder: RxFormBuilder, private route: Router, modalView: ModalView) {
        super();
        this.modalView = modalView;
    }

    ngOnInit(): void {
        this.spin = false;
        this.usCompliance = new USComplianceViewModel();
        this.attachmentArray = new Array<USComplianceDocument>();
        this.lookup<MasterLookupGroup>(
            [
                { path: MASTER_LOOKUPS.complianceCategoryLookup, propName: 'complianceCategoryLookup' },
                { path: MASTER_LOOKUPS.hRLookup, propName: 'hRLookup' },
                { path: MASTER_LOOKUPS.stateLookup, propName: 'stateLookup' }
            ]).subscribe((response: any) => {
                this.usCompliance.uSComplianceDocument = new Array<USComplianceDocument>();
                this.uSComplianceDocument = new USComplianceDocument();
                //  this.usCompliance.uSComplianceDocument.push(this.uSComplianceDocument);
                this.usComplianceFormGroup = this.formBuilder.formGroup(this.usCompliance);
                this.masterLookupGroup = response;
                this.setDefaultValues();
                this.showComponent = true;
                this.spin = false;
            })
    }


    addUSComplianceDocument() {
        if (this.attachmentArray.length >= 5 || this.uSComplianceDocument.length >= 5) {
            this.toastr.error(CustomMessage.fileCountValidation)
        }
        else {
            var compliance = new USComplianceDocument();
            compliance.isDocument = this.isDocument;
            var fomrGroup = this.formBuilder.formGroup(compliance);
            this.uSComplianceDocument = <FormArray>this.usComplianceFormGroup.controls.uSComplianceDocument;
            this.isURL = this.isURL;
            this.uSComplianceDocument.push(fomrGroup);
        }
    }

    removeUSComplianceDocument(index) {
        this.uSComplianceDocument.removeAt(index);
        this.attachmentArray.splice(index, 1);
    }

    handleFileSelect(evt, i) {
        this.fileType = "";
        this.selectedFilename  = this.uSComplianceDocument.controls[i].value.documentName.split('\\')[2]
        this.uSComplianceDocument.controls[i].controls.documentName.setValue(this.selectedFilename);

        // this.fileList = [];
        var selectedFile = evt.target.files[0];
       
        // if (selectedFiles.length > 0) {
        //     for (var index = 0; index < selectedFiles.length; index++) {

        // const max_size = 3e+6; //size filter in bytes
        // if (selectedFiles[index].size > max_size) {
        // this.toastr.error(CustomMessage.fileSizeValidation3mb);
        this.selectedFilename = selectedFile.name
        let ext = selectedFile.name.split('.').pop(),
            fileType = selectedFile.type;
        // ext = ext.toLowerCase();

        var downloadFileObj = new DownloadFile();
        var isFilesValid = downloadFileObj.fileValidation(selectedFile);
        // if (isFilesValid) {
        if (selectedFile && isFilesValid) {
            this.fileType = ext;
            var reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = this._handleReaderLoaded.bind(this, this.selectedFilename, i);
            // reader.readAsBinaryString(selectedFile);
        }
        // }
        else {
            this.uSComplianceDocument.controls[i].controls.documentName.setValue(null);
            this.uSComplianceDocument.controls[i].controls.documentName.setValidators([RxwebValidators.required()]);
            this.uSComplianceDocument.controls[i].controls.documentName.updateValueAndValidity();
        }
        
        // }
        // }
        // else
        //     this.toastr.info(CustomMessage.fileCountValidation);
    }

    _handleReaderLoaded(fileName, i, readerEvt) {
        var binaryString = readerEvt.target.result;
        var firstIndex = binaryString.indexOf("data:") + 5;
        var lastIndex = binaryString.indexOf(";base64,");
        var contentType = binaryString.substring(firstIndex, lastIndex);
        var fileModel = new USComplianceDocument();
        fileModel.contentType = contentType;
        fileModel.usComplianceDocumentId = 0;
        fileModel.documentName = fileName;
        fileModel.attachmentBase64String = binaryString.split(";base64,")[1];
        this.attachmentArray[i] = fileModel;

        if (this.attachmentArray.length > 0) {
            for (let index = 0; index < this.attachmentArray.length; index++) {
                // this.uSComplianceDocument.controls[index].controls.documentName.value = this.attachmentArray[index].attachments;
                this.uSComplianceDocument.value[index].contentType = this.attachmentArray[index].contentType;
                this.uSComplianceDocument.value[index].documentName = this.attachmentArray[index].documentName;
                this.uSComplianceDocument.value[index].isDocument = this.isDocument;
                this.uSComplianceDocument.value[index].usComplianceDocumentId = 0;
                this.uSComplianceDocument.value[index].usComplianceId = 0;
                this.uSComplianceDocument.value[index].attachmentBase64String = this.attachmentArray[index].attachmentBase64String;
            }
        }

    }

    // removeAttachment(fileIndex: number) {
    //     this.attachmentArray.splice(fileIndex, 1);
    // }

    setDefaultValues() {
        this.usComplianceFormGroup.patchValue({
            "statusId": StatusEnum.Active,
            "createdOn": new Date(),
            "createdBy": this.user.userId,
            "uSComplianceId": 0
        });
    }

    addUploadAttachments() {
        this.spin = true;
        if (this.usComplianceFormGroup.value.uSComplianceDocument.length == 0) {
            this.spin = false;
            this.toastr.error(CustomMessage.atleastOne);
        }
        else {
            if (this.attachmentArray.length > 0) {
                for (let index = 0; index < this.attachmentArray.length; index++) {
                    // this.uSComplianceDocument.controls[index].controls.documentName.value = this.attachmentArray[index].attachments;
                    this.uSComplianceDocument.value[index].documentName = this.attachmentArray[index].documentName;
                    this.uSComplianceDocument.value[index].contentType = this.attachmentArray[index].contentType;
                    this.uSComplianceDocument.value[index].isDocument = this.isDocument;
                    this.uSComplianceDocument.value[index].usComplianceDocumentId = 0;
                    this.uSComplianceDocument.value[index].usComplianceId = 0;
                    this.uSComplianceDocument.value[index].attachmentBase64String = this.attachmentArray[index].attachmentBase64String;
                }
            }

            if (this.uSComplianceDocument.length > 0) {
                for (let index = 0; index < this.uSComplianceDocument.length; index++) {
                    this.uSComplianceDocument.value[index].isDocument = this.isDocument;
                    this.uSComplianceDocument.value[index].usComplianceDocumentId = 0;
                    this.uSComplianceDocument.value[index].usComplianceId = 0;
                }
            }

            if (this.usComplianceFormGroup.valid) {
                this.post({ body: this.usComplianceFormGroup.value }).subscribe(response => {
                    this.spin = false;
                    this.toastr.success(CustomMessage.dataAdded);
                    this.route.navigate([RoutingKeys.UploadAttachments]);
                })
            }
        }
    }

    selectCategory(value) {
        this.addButton = true;
        this.usComplianceFormGroup.controls.uSComplianceDocument.reset();
        this.attachmentArray = new Array<USComplianceDocument>();

        var length = this.uSComplianceDocument.length;
        for (var index = 0; index < length; index++) {
            this.uSComplianceDocument.removeAt(0);
        }
        // if (this.usComplianceFormGroup.value.categoryId != null) {
        //     this.modalView.show(ConfirmationModalComponent, { componentType: 'changeCategory' }).then(t => {
        //         if (t == 'yes') {
        //             this.spin = true;                   
        //             this.spin = false;
        //         }
        //     })
        // }

        if (value.sourceItem.applicationObjectId == USComplianceCategoryEnum.HumanResourceComplianceFormFiles) {
            this.isStateLookup = false;
            this.isComplianceLookup = true;
            this.isURL = false;
            this.isDocument = true;
            this.usComplianceFormGroup.value.categoryId = value.sourceItem.applicationObjectId;
        }
        else if (value.sourceItem.applicationObjectId == USComplianceCategoryEnum.StateLawAndForms) {
            this.isComplianceLookup = false;
            this.isStateLookup = true;
            this.isURL = false;
            this.isDocument = true;
            this.usComplianceFormGroup.value.categoryId = value.sourceItem.applicationObjectId;
            this.masterLookupGroup.stateLookup = this.masterLookupGroup.stateLookup.filter(t => t.countryId == StorageKeys.USACountryId);
        }
        else if (value.sourceItem.applicationObjectId == USComplianceCategoryEnum.AdditionalOnlineFormsAndPostersLibrary) {
            this.get({ path: "api/UploadAttachments/category" }).subscribe(response => {
                if (response == true) {
                    //this.uSComplianceDocument.controls.title.setValue(null);
                    this.usComplianceFormGroup.controls.categoryId.setValue(null);
                    this.usComplianceFormGroup.controls.categoryId.updateValueAndValidity();
                    this.addButton = false;
                    this.toastr.warning(CustomMessage.categoryAdded);
                }
                else {
                    this.isStateLookup = false;
                    this.isComplianceLookup = false;
                    this.isDocument = false;
                    this.isURL = true;
                }
            })
        }
    }

    selectCompliance(value) {
        this.usComplianceFormGroup.value.hRComplianceId = value.sourceItem.hrComplianceId;
        this.usComplianceFormGroup.controls.stateId.setValue(null);
    }

    selectState(value) {
        this.usComplianceFormGroup.value.stateId = value.sourceItem.stateId;
        this.usComplianceFormGroup.controls.hrComplianceId.setValue(null);
    }

    ngOnDestroy(): void {
        if (this.subscription)
            this.subscription.unsubscribe();
    }
}